//配置全局访问接口地址
// let commonUrl = 'https://softbauk.cc';
let commonUrl = window.location.origin;

let baseUrl = {
    commonUrl
}

export default baseUrl
